import { CORE_TEMPLATES } from './coreTemplates';
import { EXTRA_TEMPLATES } from './extraTemplates';

export * from './shared';

const ALL_TEMPLATES = [...CORE_TEMPLATES, ...EXTRA_TEMPLATES];

/**
 * Wszystkie szablony wbudowane. Podzielone na dwa pliki wyłącznie z powodu
 * limitu długości pliku w tym repo — kolejność na liście jest tą, którą widzi
 * użytkownik w panelu.
 *
 * „Pusta plansza" idzie na początek, bo to stan, w którym otwiera się nowa
 * kreacja: pozycja na liście ma odpowiadać temu, co użytkownik widzi na
 * planszy, zanim cokolwiek kliknie.
 */
export const TEMPLATES = [
  ...ALL_TEMPLATES.filter((template) => template.id === 'blank'),
  ...ALL_TEMPLATES.filter((template) => template.id !== 'blank'),
];
